<template>
  <button class="download-file-card" :style="{ color }">
    <div class="overflow">
      <div class="icon-container">
        <ets-spinner v-if="loading" :size="24" class="spinner" />
        <ets-icon v-else class="icon" :icon="icon" />
      </div>
      <div class="subtitle" :style="{ color }">{{ name }}</div>
      <div class="line" :style="{ backgroundColor: color }" />
    </div>
  </button>
</template>

<script>
export default {
  name: "DownloadFileCard",
  props: {
    name: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: "download"
    },
    loading: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "#058dc7"
    }
  }
};
</script>

<style lang="scss" scoped>
$default_color: map-get($button_colors, "default_color");

.download-file-card {
  margin: 2rem;
  border: none;
  background: transparent;
  box-shadow: 0 0 0 1px $color-grey5 inset;
  font-size: 1.2rem;
  padding: 0;
  position: relative;
  transition: all 0.3s ease-out;
  &:hover {
    background: $color-grey6;
    box-shadow: 0 0 0 2px currentColor inset;
    text-decoration: none;
  }
  cursor: pointer;
}
.overflow {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 3rem;
  overflow: hidden;
  &:hover {
    .line {
      transform: scaleY(2);
    }
    .icon {
      fill: $color-grey1;
    }
  }
}
.subtitle {
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: 2px;
  margin-top: 2rem;
  text-align: center;
}
.line {
  height: 0.6rem;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  transition: transform 0.3s ease-out;
  transform-origin: 0 100%;
}
.icon {
  fill: $default_color;
}
.icon-container {
  display: inline-flex;
  padding: 0.5rem;
  border: 1px solid rgba(0, 0, 0, 0.2);
}
.spinner {
  display: block;
  margin: 0 auto;
  width: 24px;
  height: 24px;
}
</style>
